import React from 'react';
import ats from "../assets/img/footer_logo.png";
import Ucom from "../assets/img/Ucom.jpg";
import { login } from "../translate";
import tel from "../assets/img/telegram-logo.png";
import whatsapp from "../assets/img/whatsapp--v2.png";

const { REACT_APP_SERVER } = process.env;

function LogRegSide(props) {
    return (
        <div className="loginAside">
            <figure className="logoLogin">
                <img style={REACT_APP_SERVER === 'ATS' ? { width: '100%', objectFit: 'scale-down' } : { width: '100%', objectFit: 'cover' }} src={REACT_APP_SERVER === 'ATS' ? ats : Ucom} alt="" />
            </figure>
            <section style={{height: 'calc(100% - 190px)'}} className="d-flex flex-column align-items-center justify-content-between">
                <div className="d-flex flex-column align-items-center justify-content-center">
                    <p className="contact">
                        {login.contact[+localStorage.getItem('atsLang') || 1]}
                    </p>
                    <a style={{ marginTop: 10, marginBottom: 0 }} href="mailto:info@ats.am"><b>Email:</b> info@ats.am</a>
                        <a style={{ margin: 0 }} href="tel:+37444720101"><b>Phone:</b> +37444720101</a>

                </div>
                <div className="d-flex flex-row align-items-center justify-content-around">
                    <a href="https://t.me/ATS_Support"><img style={{ width: 30, height: 30,marginRight: 10 }} src={tel} alt="" /> </a>
                    <a href="https://wa.me/37444720101"><img style={{ width: 30, height: 30,}} src={whatsapp} alt="" /> </a>

                </div>
            </section>

        </div>
    );
}

export default LogRegSide;
